// src/integrations/supabase/client.ts
import { createClient } from '@supabase/supabase-js';

const envUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const envAnon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

// Fallback to connected project (publishable anon key) to avoid hard crash in sandbox previews
const fallbackUrl = 'https://kpqpswkalqbtbviogmcz.supabase.co';
const fallbackAnon = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtwcXBzd2thbHFidGJ2aW9nbWN6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA2MjY2NTMsImV4cCI6MjA2NjIwMjY1M30.q14UOHpDXUguePTszygAw7X7oESfCfV4reKJPEyJ1ls';

const supabaseUrl = envUrl || fallbackUrl;
const supabaseAnonKey = envAnon || fallbackAnon;

if (!envUrl || !envAnon) {
  console.warn('[Supabase] Using fallback URL/key from project config. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY for your environment.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface Profile {
  id: string;
  email: string;
  full_name?: string;
  company_name?: string;
  created_at: string;
  updated_at: string;
}

export interface Business {
  id: string;
  user_id: string;
  business_name: string;
  website_url: string;
  industry?: string;
  address?: string;
  phone?: string;
  description?: string;
  created_at: string;
  updated_at: string;
}

export interface SocialAccount {
  id: string;
  business_id: string;
  platform: string;
  account_url?: string;
  account_id?: string;
  access_token?: string;
  refresh_token?: string;
  token_expires_at?: string;
  is_connected: boolean;
  last_sync_at?: string;
  created_at: string;
  updated_at: string;
}

export interface BrandReport {
  id: string;
  business_id: string;
  report_type: string;
  overall_score: number;
  website_score?: number;
  social_score?: number;
  reputation_score?: number;
  visibility_score?: number;
  consistency_score?: number;
  positioning_score?: number;
  analysis_data: any;
  recommendations?: any;
  report_status: string;
  processing_started_at?: string;
  processing_completed_at?: string;
  created_at: string;
  updated_at: string;
}